import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';

@Component({
    selector: 're-profile-sync-confirmation-dialog',
    templateUrl: './profile-sync-confirmation-dialog.component.html',
    styleUrls: ['./profile-sync-confirmation-dialog.component.scss'],
    standalone: false
})
export class ProfileSyncConfirmationDialogComponent implements OnInit {

  constructor(private activeModal: NgbActiveModal, private router: Router) { }
  public customerName: string;
  public environmentName: string;
  public corporationName: string;
  public dialogTitle: string = 'Sync MatrixCare 360 Access Profile';
  public confirmButtonText: string = 'Yes, Sync Access Profile';

  ngOnInit(): void {
  }


  sync() {
    this.activeModal.close(true);
  }

  close() {
    this.activeModal.close(false);
  }

}
